document.addEventListener("DOMContentLoaded", () => {

  // ─── Mobile menu ─────────────────────────────────────────────────────────
  const burger = document.querySelector(".js-burger");
  const menu   = document.querySelector(".js-header-nav");
  if (burger && menu) {
    burger.addEventListener("click", () => {
      const open = menu.classList.toggle("active");
      burger.classList.toggle("active", open);
      document.body.classList.toggle("locked", open);
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 992) {
        menu.classList.remove("active");
        burger.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Copy-link share button (single.php) ────────────────────────────────
  document.querySelectorAll(".js-copy-link").forEach((btn) => {
    btn.addEventListener("click", () => {
      const url = btn.getAttribute("data-url");
      if (!url || !navigator.clipboard) return;
      navigator.clipboard.writeText(url).then(() => {
        btn.classList.add("is-copied");
        setTimeout(() => btn.classList.remove("is-copied"), 2000);
      });
    });
  });

  // ─── Back to top ─────────────────────────────────────────────────────────
  const backToTop = document.querySelector(".js-back-to-top");
  if (backToTop) {
    const toggle = () => backToTop.classList.toggle("is-visible", window.scrollY > 400);
    window.addEventListener("scroll", toggle, { passive: true });
    toggle();
    backToTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

});
